// @flow

import { LazyLoadComponent } from '@zapier/common-components';

const LazyLoadMaybeCompleteGoalsAndCelebrate = LazyLoadComponent({
  loader: () =>
    import(
      /* webpackChunkName: 'app-member-home-components-user-skill-levels-MaybeCompleteGoalsAndCelebrate' */ 'app/member-home/components/UserSkillLevels/MaybeCompleteGoalsAndCelebrate/MaybeCompleteGoalsAndCelebrate'
    ),
});

export const LazyLoadMaybeCompleteGoalsAndCelebrateWithContext = LazyLoadComponent(
  {
    loader: () =>
      import(
        /* webpackChunkName: 'app-member-home-components-user-skill-levels-MaybeCompleteGoalsAndCelebrate' */ 'app/member-home/components/UserSkillLevels/MaybeCompleteGoalsAndCelebrate/MaybeCompleteGoalsAndCelebrateWithContext'
      ),
  }
);

export default LazyLoadMaybeCompleteGoalsAndCelebrate;
